import {
  functionImg1D,
  functionImg1M,
  functionImg1T,
  functionImg2D,
  functionImg2M,
  functionImg2T,
  functionImg3D,
  functionImg3M,
  functionImg3T,
  functionImg4D,
  functionImg4M,
  functionImg4T,
  functionImg5D,
  functionImg5M,
  functionImg5T,
  functionImg6D,
  functionImg6M,
  functionImg6T,
  functionImg7D,
  functionImg7M,
  functionImg7T,
} from '@assets/images/main/access/components/index';
export default {
  functions: {
    title: 'Phần mềm<br/>dễ dàng sử dụng cho mọi người',
    desc: 'ORBRO đã phát triển phần mềm dựa trên 8 năm kinh nghiệm trong lĩnh vực quản lý ra vào. Phần mềm<br/>được thiết kế theo phản hồi và yêu cầu của người dùng, nhằm tối đa hóa sự tiện lợi khi sử dụng thực tế.<br/>Đây là sản phẩm được phát triển từ nhu cầu thực tiễn, mang lại giá trị lợi ích thiết thực trong quản lý ra vào.',
    line: 3,
    card: [
      {
        size: '4',
        tag: 'Đăng ký người dùng',
        title: 'Có thể mời người dùng bằng<br/>số điện thoại, email',
        label: 'Quản trị viên',
        img: {
          desktop: functionImg1D,
          tablet: functionImg1T,
          mobile: functionImg1M,
        },
      },
      {
        size: '4',
        tag: 'Quản lý quyền truy cập',
        title: 'Dễ dàng và thuận tiện<br/>quản lý ra vào',
        label: 'Quản trị viên',
        desc: 'Chỉ cần đăng ký thiết bị<br/>rồi hoàn tất tạo quyền ra vào',
        img: {
          desktop: functionImg2D,
          tablet: functionImg2T,
          mobile: functionImg2M,
        },
      },
      {
        size: '2',
        tag: 'Tải xuống Excel',
        title: 'Hỗ trợ tải xuống<br/>lịch sử ra vào và thông tin người dùng',
        label: 'Quản trị viên',
        img: {
          desktop: functionImg3D,
          tablet: functionImg3T,
          mobile: functionImg3M,
        },
      },
      {
        size: '2',
        tag: 'Điều khiển từ xa',
        title: 'Có thể điều khiển<br/>cửa từ xa',
        label: 'Quản trị viên',
        img: {
          desktop: functionImg4D,
          tablet: functionImg4T,
          mobile: functionImg4M,
        },
      },
      {
        size: '2',
        tag: 'Ra vào tự động',
        title: 'Khi không bật ứng dụng<br/>cũng có thể ra vào',
        label: 'Người dùng',
        img: {
          desktop: functionImg5D,
          tablet: functionImg5T,
          mobile: functionImg5M,
        },
      },
      {
        size: '4',
        tag: 'Tiện ích di động',
        title: 'Cung cấp widget giúp<br/>chạy ứng dụng<br/>nhanh chóng',
        label: 'Người dùng',
        img: {
          desktop: functionImg6D,
          tablet: functionImg6T,
          mobile: functionImg6M,
        },
      },
      {
        size: '4',
        tag: 'Ra vào tự động',
        title: 'Dễ dàng cài đặt<br/>khoảng cách cửa mở',
        label: 'Người dùng',
        img: {
          desktop: functionImg7D,
          tablet: functionImg7T,
          mobile: functionImg7M,
        },
      },
    ],
  },
};
